
import React, { Component } from 'react';

class LayoutStandardWidth extends Component {
  static defaultProps = {
    classes: "",
  };
  render() {
    return (
      <div className={`content-wrapper container-standard-content ${this.props.classes}`}>
        {this.props.children}
      </div>
    );
  }
}

export default LayoutStandardWidth;
